import { useEffect, useState } from "react";
import { toast } from "sonner";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";

const AudioPermission = () => {
  const [permissionState, setPermissionState] = useState(null);
  const [toastDisplayed, setToastDisplayed] = useState(false); // Flag to track toast display

  useEffect(() => {
    // Check the microphone permission state
    navigator.permissions
      .query({ name: "microphone" })
      .then((permissionStatus) => {
        setPermissionState(permissionStatus.state);
        console.log("Microphone permission state is: ", permissionStatus.state);
        permissionStatus.onchange = () => {
          setPermissionState(permissionStatus.state);
          console.log(
            "Microphone permission state has changed to: ",
            permissionStatus.state
          );

          // Show toast if permission state is prompt and toast hasn't been displayed
          if (permissionStatus.state === "prompt" && !toastDisplayed) {
            showToast();
            setToastDisplayed(true); // Set the flag to true after displaying the toast
          }
        };
      });
  }, [toastDisplayed]); // Add toastDisplayed to the dependency array

  useEffect(() => {
    // Show toast if permission state is prompt and toast hasn't been displayed
    showToast();
    setToastDisplayed(true); // Set the flag to true after displaying the toast
  }, [toastDisplayed]); // Add permissionState to the dependency array
  // Function to request microphone access
  const requestMicrophoneAccess = () => {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        console.log("Microphone access granted.");
        // Stop the stream after getting the permission
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch((error) => {
        console.error("Microphone access denied:", error);
      });
  };

  // Function to enable sound (you can customize this action)
  const enableSound = () => {
    // Logic to enable sound goes here
    console.log("Sound enabled!");
    toast.success("Sound has been enabled!", {
      position: "top-right",
      autoClose: 3000, // Automatically close after 3 seconds
    });
  };
  const { t } = useTranslation();

  const showToast = () => {
    toast.success(t("audioPermission"), {
      icon: "🔔",
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      action: {
        label: t("allowAccess"),
        onClick: () => requestMicrophoneAccess(),
      },
      style: {
        backgroundColor: "#fef2e8",
        color: "black",
        border: "2px solid #f78220",
      },
      // Adding an action button to enable sound
      actionButtonStyles: {
        marginTop: "10px",
      },
      // Add another button to enable sound
      onClick: enableSound,
    });
  };

  return null; // No longer rendering anything in the component
};

export default AudioPermission;
